<button
  #ngbTooltip="ngbTooltip"
  [attr.title]="title"
  [attr.aria-label]="ariaLabel"
  [attr.aria-labelledby]="ariaLabelledby"
  [class.ds-cursor--pointer]="!!content"
  [ngbTooltip]="content"
  [placement]="placement"
  (hidden)="ariaExpanded = false"
  (shown)="ariaExpanded = true"
  (keydown)="closeTooltip($event, ngbTooltip)"
  [attr.aria-expanded]="ariaExpanded"
  [tooltipClass]="tooltipClass"
  autoClose="outside"
  class="ds-icon ds-icon--info ds-tooltip"
  data-cy="tooltip"
  triggers="click"
  type="button"
>
</button>
